import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
import { SectionTitle } from './ui/Section';
export function Testimonials() {
  return <section className="bg-canvas px-4 py-12 md:py-16" data-id="element-218" data-mp="3fze3dwmz31v5">
      <div className="mx-auto max-w-6xl" data-id="element-219" data-mp="3fy2w3mubjbza">
        <SectionTitle data-id="element-220" data-mp="3b0uebnd319yk">People using the system</SectionTitle>

        <div className="mt-8 grid gap-5 md:grid-cols-3" data-id="element-221" data-mp="3b0axk9z64rm4">
          {testimonials.map(item => <figure key={item.name} className="flex flex-col rounded-2xl border border-navy/10 bg-white p-6 shadow-sm" data-id="element-222" data-mp="370ajwrjw8kg4">
              <div className="flex gap-0.5" role="img" aria-label="5 out of 5 stars" data-id="element-223" data-mp="3228xpxr6850f">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-brand text-brand" aria-hidden="true" data-id="element-224" data-mp="2s2rwbsiycda9" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-navy" data-id="element-225" data-mp="v7c8jc02nfs1">“{item.quote}”</blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-navy/10 pt-4" data-id="element-226" data-mp="q8ixdq89c0v1">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-navy font-display text-xs font-black text-white" data-id="element-227" data-mp="h8awv9l20jp4">
                  {item.initials}
                </span>
                <span data-id="element-228" data-mp="c6vejpa9graf">
                  <span className="block text-sm font-extrabold uppercase text-navy" data-id="element-229" data-mp="c6bwm8km22we">{item.name}</span>
                  <span className="block text-xs text-steel" data-id="element-230" data-mp="zw64ebq2p19s">{item.role}</span>
                </span>
              </figcaption>
            </figure>)}
        </div>
        <p className="mt-6 text-center text-xs text-steel" data-id="element-231" data-mp="q6ml54yg75ee">Individual experiences may vary.</p>
      </div>
    </section>;
}